// extracted by mini-css-extract-plugin
export default {"wraper":"pop-up-wraper_wraper__wTLZT","closeButton":"pop-up-wraper_closeButton__h+JY1","contentWraper":"pop-up-wraper_contentWraper__VdR+o"};